import * as o2Api from "../api";

export const acceptLogin = async (params) => {
    try {
        const {data: result} = await o2Api.acceptLogin(params);
        const {responseBody, responseCode, responseMessage} = result;
        if (responseCode === "200") {
            // 성공
            return {
                responseCode: responseCode,
                responseBody: responseBody
            };
        } else {
            return {
                responseCode: responseCode,
                responseMessage: responseMessage
            }
        }
    } catch (e) {
        return {
            responseCode: "999",
            responseMessage: e.message
        };
    }
};

export const getPosUserList = async (params) => {
    try {
        const {data: result} = await o2Api.getPosUserList(params);
        const {responseBody, responseCode, responseMessage} = result;
        if (responseCode === "200") {
            // 성공
            return responseBody;
        } else {
            return [];
        }
    } catch (e) {
        console.error(e.message);
        return [];
    }
}
